/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ServicePointOrderModel } from '@/api/service-point/order/order.model';
import orderState from '@/modules/service-point/constants/order.constant';

/**
 * Component.
 */
@Component({ name: 'item-summary-component' })
export default class extends Vue {
  /**
   * Property `orderState`.
   */
  orderState = orderState;

  /**
   * Property `order`.
   */
  @Prop({ type: Object })
  order: ServicePointOrderModel;

  /**
   * Property `isLastOrder`.
   */
  @Prop({ default: true })
  isLastOrder: boolean;

  /**
   * Getter `orderDetail`.
   */
  get orderDetail() {
    const { delivery: order = null, packages = [], status, statusDate } =
      this.order || {};
    const {
      client: { name: clientName },
      orderCode,
      trackingNumber
    } = order || {};
    const data = {
      clientName,
      orderCode,
      packages,
      status,
      statusDate,
      trackingNumber
    };

    return data;
  }

  /**
   * Getter `isOrderCollect`.
   */
  get isOrderCollect() {
    const { status } = this.orderDetail;
    const { code } = status || {};

    return (
      code === this.orderState.RECEIVE_PENDING_TO_COLLECT ||
      code === this.orderState.TO_COLLECT ||
      code === this.orderState.COLLECTED
    );
  }

  /**
   * Getter `isOrderReceivedByServicePoint`.
   */
  get isOrderReceivedByServicePoint() {
    const { status } = this.orderDetail;
    const { code } = status || {};

    return code === this.orderState.RECEIVED;
  }

  /**
   * Getter `isOrderCollectedByServicePoint`.
   */
  get isOrderCollectedByServicePoint() {
    const { status } = this.orderDetail;
    const { code } = status || {};

    return code === this.orderState.TO_COLLECT;
  }

  /**
   * Getter `isOrderSuccessful`.
   */
  get isOrderSuccessful() {
    const { status } = this.orderDetail;
    const { code } = status || {};

    return (
      code === this.orderState.DELIVERED || code === this.orderState.COLLECTED
    );
  }

  /**
   * Getter `isOrderUnsuccessful`.
   */
  get isOrderUnsuccessful() {
    const { status } = this.orderDetail;
    const { code } = status || {};

    return (
      code === this.orderState.CANCELED ||
      code === this.orderState.NOT_DELIVERED ||
      code === this.orderState.TO_COLLECT
    );
  }
}
